import { render, staticRenderFns } from "./memeberCenterXft.vue?vue&type=template&id=772a54cc&scoped=true&"
import script from "./memeberCenterXft.vue?vue&type=script&lang=js&"
export * from "./memeberCenterXft.vue?vue&type=script&lang=js&"
import style0 from "./memeberCenterXft.vue?vue&type=style&index=0&id=772a54cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772a54cc",
  null
  
)

export default component.exports